export default function() {}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-shape/src/noop.js
// module id = null
// module chunks = 